module.exports = __webpack_public_path__ + "media/damages/miejsce-uszkodzenia@3x-452dcf7d.svg";